@use 'sass:map';
@use 'sass:list';

@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/colours';
@import '../../global/style/nano-theme/layers';

:host {
  /**
   * @prop --padding-start: padding at the start of nav-items (left r2l / right l2r). Defaults to '10px'
   * @prop --padding-end: padding at the end of nav-items (right r2l / left l2r). Defaults to '10px'
   * @prop --padding-top: padding at the top of nav-items. Defaults to '10px'
   * @prop --padding-bottom: padding at the bottom of nav-items. Defaults to '10px'

   * @prop --secondary-padding-top: padding at the top of nested nav-items. Defaults to 0
   * @prop --secondary-padding-bottom: padding at the bottom of nested nav-items. Defaults to 0

   * @prop --bg-color-hover: bg hover color of nav-items. Defaults to #{map.get($colors, blue--faded)};
   * @prop --bg-color-focus: bg focus color of nav-items. Defaults to #{map.get($colors, blue--faded)};
   * @prop --bg-color-selected: bg selected color of nav-items. Defaults to #{map.get($colors, blue--faded)};

   * @prop --color-hover: text hover color of nav-items. Defaults to #{map.get($colors, blue)}
   * @prop --color-selected: text selected color of nav-items. Defaults to #{map.get($colors, blue)}
   * @prop --color-focus: text focus color of nav-items. Defaults to #{map.get($colors, blue)}

   * @prop --focus-outline: the focus style of nav-items. Defaults to 'none'
   * @prop --font-size: default font-size for all items. Defaults .9em;
  */

  --padding-start: #{$spacing-medium};
  --padding-end: #{$spacing-medium};
  --padding-top: #{$spacing-small};
  --padding-bottom: #{$spacing-small};
  --secondary-padding-top: 0;
  --secondary-padding-bottom: 0;
  --bg-color-hover: #{map.get($colors, blue--faded)};
  --bg-color-focus: #{map.get($colors, blue--faded)};
  --bg-color-selected: #{map.get($colors, blue--faded)};
  --color-hover: #{map.get($colors, blue)};
  --color-selected: #{map.get($colors, blue)};
  --color-focus: #{map.get($colors, blue)};
  --focus-outline: none;
  --font-size: 0.9em;

  display: block;
}

.menu {
  font-size: var(--font-size, 0.9em);
  overscroll-behavior: none;
  min-width: var(--width);
  position: relative;

  &:focus {
    outline: none;
  }
}

::slotted(*:not(nano-nav-item):not(nano-option):not(hr):not(slot)) {
  padding-inline: var(--padding-start) var(--padding-end);
  padding-block: var(--padding-top) var(--padding-bottom);
  display: block;
}
